import { track } from '@tldraw/tldraw'
import { Color, GradientColor, GradientStop } from 'components/VisualStudioPlayground/VisualEditor/Types'
import { observer } from 'mobx-react-lite'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Trash2 } from 'blaze-ui/icons'
import { getDefaultColor } from './utils'

interface Props {
  selectedColor: GradientColor
  onNewColorChange: (color: Color) => void
  stopToDelete: GradientStop
}

export const DeleteGradientStopButton = track(
  observer(({ selectedColor, stopToDelete, onNewColorChange }: Props) => {
    const handleDeleteStop = (stop: GradientStop) => {
      let newColor: Color = {
        ...selectedColor,
        stops: selectedColor.stops.filter((existingStop) => existingStop !== stop),
      }

      if (newColor.stops.length <= 1) {
        newColor = getDefaultColor(newColor)
      }

      onNewColorChange(newColor)
    }

    return (
      <IconButton
        aria-label={`Delete stop at ${stopToDelete.position * 100}%`}
        variant="ghost"
        icon={() => <Trash2 color="var(--dark-80)" />}
        onPress={() => handleDeleteStop(stopToDelete)}
      />
    )
  }),
)
